import { useContext, useState } from 'react';
import styled from 'styled-components';
import { ApiContext } from '../../contexts/ApiContext';
import { useProductsByIds } from '../../hooks/useProductsByIds';
import { assetUrl } from '../../utils/assets';
import { formatPriceUsd } from '../../utils/price';
import Spinner from '../spinner/Spinner';

// PARCHE PROVISORIO: de los kits del equipo se destaca el de mantenimiento o
// servicio, que es el que tiene sentido al lado de la reparación standard.
//
// Antes esto era un .slice(1, 2), o sea "el segundo de la lista", y por lo tanto
// dependía del orden en que respondiera la API: para el mismo Pisón Bomag BT65,
// una base devolvía "Kit de Servicio BT60-BT65" y la otra "Kit Embrague Bomag
// BT65", así que la card mostraba distinto producto en cada entorno.
//
// Sigue siendo una heurística sobre el nombre: se rompe si alguien nombra un kit
// "Service BT65" o "Mant. BT65". TODO: reemplazar por un flag del backend
// (ej. "destacado") cuando se defina el criterio de fondo.
const KIT_DESTACADO = /mantenimiento|servicio/i;

function elegirKitDestacado(products) {
    const porNombre = products.find(item =>
        KIT_DESTACADO.test(item?.producto?.nombre_producto ?? '')
    );
    return porNombre ?? products[0];
}

export default function ProductCardEspecial({ product, type }) {

    const { rates } = useContext(ApiContext);
    const { products, loading } = useProductsByIds({ product, type });
    const [selectedProduct, setSelectedProduct] = useState(null); // 👈 estado modal

    if (loading) {
        return <Spinner />;
    }

    const featured = elegirKitDestacado(products);

    if (!featured) {
        return (
            <h5 style={{ marginTop: '2rem' }}>
                No hay Datos disponibles para este producto
            </h5>
        );
    }

    const { producto, precio } = featured;
    const price = formatPriceUsd(precio, rates);

    return (
        <>
            <StyledProductCardEspecial>
                <div className="card">
                    {producto.imagen_grande &&
                        <img
                            src={assetUrl(producto.imagen_grande)}
                            className="card-img-top"
                            style={{ padding: '1rem' }}
                            alt={`Imagen de ${producto.nombre_producto}`}
                        />
                    }

                    <div className="card-body">
                        <h4 className="card-title">
                            <strong>{producto.nombre_producto}</strong>
                        </h4>

                        {/* 👇 ABRE MODAL FULLSCREEN */}
                        <p className="verDetalle" onClick={() => setSelectedProduct(featured)}>
                            Ver Detalle...
                        </p>

                        {price && <button className='btn btn-warning btnPrice'>{price}</button>}
                    </div>
                </div>
            </StyledProductCardEspecial>

            {/* 🔥 MODAL FULLSCREEN */}
            {selectedProduct && (
                <ModalOverlay onClick={() => setSelectedProduct(null)}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>

                        <button className="closeBtn" onClick={() => setSelectedProduct(null)}>
                            X
                        </button>

                        <h2>{selectedProduct.producto.nombre_producto}</h2>
                        {selectedProduct.producto.quinta_imagen ? (
                            <img
                                src={assetUrl(selectedProduct.producto.quinta_imagen)}
                                className="card-img-top"
                                style={{ padding: '1rem' }}
                                alt={`Imagen de ${selectedProduct.producto.nombre_producto}`}
                            />
                        ) : (
                            <p style={{ marginTop: '1rem' }}>
                                Sin detalles momentáneamente
                            </p>
                        )}

                    </ModalContent>
                </ModalOverlay>
            )}
        </>
    );
}

const StyledProductCardEspecial = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    max-height: 530px;
    overflow-y: auto;

    .card{
        margin-top: 0.5rem;
        background-color: var(--colorFondoPrincipal);
        border: none;
    }

    .card-img-top{
        margin: 0 auto;
        width: 80%
    }

    .btnPrice{
        width: -webkit-fill-available;
        padding: 0.6rem;
    }

    .verDetalle{
        cursor: pointer;
        color: #0d6efd;
        margin-bottom: 0.5rem;
    }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: white;
  width: 100%;
  max-width: 950px;
  padding: 2rem;
  border-radius: 8px;
  position: relative;

  .closeBtn {
    position: absolute;
    top: 10px;
    right: 15px;
    border: none;
    background: none;
    font-size: 1.2rem;
    cursor: pointer;
  }
`;
